import { Component, ElementRef, Input, ViewChild } from '@angular/core';
declare var $: any;
@Component({
  selector: 'tic-top-hotel-carousel',
  templateUrl: './top-hotel-carousel.component.html',
  styleUrls: ['./top-hotel-carousel.component.scss']
})
export class TopHotelCarouselComponent {
  @Input() itemList!: any[];
  @ViewChild('hotels') hotels: ElementRef;

  ngAfterViewInit() {
    $(this.hotels.nativeElement).slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      centerMode: true,
      centerPadding: "0",
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
          },
        },
      ],
    });
  }

}
